module.exports = __webpack_public_path__ + "static/img/8a.fd088657.png";